import { render, staticRenderFns } from "./PasswordWarning.vue?vue&type=template&id=f1210dac&"
import script from "./PasswordWarning.vue?vue&type=script&lang=js&"
export * from "./PasswordWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports